import { render, staticRenderFns } from "./MedicalAlerts.vue?vue&type=template&id=b5e34af6&"
import script from "./MedicalAlerts.vue?vue&type=script&lang=js&"
export * from "./MedicalAlerts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports